import type { OverviewIssue } from '../../lib/dashboard/overview/buildOverviewStatus';
import type { HomePlaylistCard } from './buildHomePlaylistCards';
import { HomeAttentionRail } from './HomeAttentionRail';
import { HomeRecentRail } from './HomeRecentRail';

type HomeSideRailsProps = {
  recent: HomePlaylistCard[];
  issues: OverviewIssue[];
  hasScreens: boolean;
  canManage: boolean;
};

export function HomeSideRails({ recent, issues, hasScreens, canManage }: HomeSideRailsProps) {
  return (
    <aside className="flex w-full max-w-full flex-[1_1_300px] flex-col gap-5">
      <HomeAttentionRail issues={issues} hasScreens={hasScreens} canManage={canManage} />
      <HomeRecentRail recent={recent} />
    </aside>
  );
}
